import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-delete-policy-modal',
	templateUrl: './delete-policy-modal.component.html',
	standalone: false,
})
export class DeletePolicyModalComponent {
	constructor(private dialogRef: MatDialogRef<DeletePolicyModalComponent>) {}

	deletePolicy() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close(false);
	}
}
